<template>
  <div>
    <div class="lds-facebook"  v-if="!loading"><div></div><div></div><div></div></div>
    <div class="row" v-if="loading">
      <div class="col-md-7 col-12">
        <Meetings></Meetings>
      </div>
      <div class="col-md-5 col-12">
        <NewMeeting></NewMeeting>
      </div>
    </div>
      <!-- <div class="row">
        <form id="form" enctype="multipart/form-data">
          <input type="text"  name="name" v-model="form.name" placeholder="">
          <input type="text"  name="email" v-model="form.email" placeholder="">
          <input type="text"  name="password" v-model="form.password" placeholder="">
          <input type="text"  name="client_secret" v-model="form.client_secret" placeholder="">
          <input type="text"  name="app_url" v-model="form.app_url" placeholder="">
          <input type="file"  name="myFile" accept=".png,.jpg"/>
           <button type="submit" class="btn btn-primary" @click="submit($event)">Submit</button>
        </form>
      </div> -->
  </div>
</template>
<script>
import { StatsCard, ChartCard } from "@/components/index";
import NotificationTemplate from './Notifications/NotificationTemplate';
import NewMeeting from '../components/NewMeeting'
import Meetings from './Meetings'

import API from '../services/api';
import Chartist from 'chartist';
import moment from 'moment'
export default {
  components: {
    StatsCard,
    ChartCard,
    NewMeeting,
    Meetings
  },
  data() {
    return {
      form: {
        name:'',
        email:'',
        password:'',
        client_secret:'',
        app_url:'',
        image:''
      },
      loading:false,
    };
  },
  computed: {
    async userLogin() {
      return this.$store.state.auth.user;
    }
  },
  mounted(){
    if(localStorage.lang!=null) this.$i18n.locale=localStorage.lang; 
  },
  created(){
   if(this.userLogin){
      this.getMeetings()
   }
    
  },
  methods: {
    async getMeetings(){
      await this.$store.dispatch('getMeetings')
      this.loading = true
    },
    moment,
    submit(e){
        e.preventDefault();
        var formm = document.getElementById('form')
        var formData = new FormData(formm)
        
        API.post('/service_client',formData)
          .then(res => console.log(res,"res"))
          .catch(error => console.log(error));
      
    },
    setLogo(){
      API.get(`/service_client/${this.userLogin.email}`)
        .then(res =>{
          this.$store.dispatch('auth/setLogo', res.data.logo)
        })
    }
  }
};
</script>
<style>
</style>
